const initialState = {
  activities: {},
  activityGroups: {},
  coachs: {}
};

// TYPES
export const ADD_ENTITY_LIST = 'Entities/ADD_LIST';
export const ADD_ENTITY = 'Entities/ADD';

// ACTION CREATORS
export const addEntities = (entityType, entityList) => {
  return {
    type: ADD_ENTITY_LIST,
    entityType,
    payload: entityList
  };
};

export const addEntity = entity => {
  return {
    type: ADD_ENTITY,
    payload: entity
  };
};

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_ENTITY_LIST: {
      let nextState = state;

      Object.values(action.payload).forEach(entity => {
        nextState = {
          ...nextState,
          [action.entityType]: {
            ...nextState[action.entityType],
            [entity.id]: {
              ...entity
            }
          }
        };
      });

      return nextState;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/entities.js